import { call, put, takeEvery } from "redux-saga/effects";
import {
  getLegalEntityList,
  hideLegalEntityListLoader,
  setLegalEntityProfile,
  setLegalEntityList,
  setErrorLegalEntityProfile,
  showLegalEntityListLoader,
  setLegalEntityProfileLoader,
} from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import {
  ADD_LEGAL_ENTITY,
  DELETE_LEGAL_ENTITY,
  GET_LEGAL_ENTITY_PROFILE,
  GET_LEGAL_ENTITY_LIST,
  UPDATE_LEGAL_ENTITY_PROFILE,
} from "./actionTypes";
import {
  getLegalEntity,
  postLegalEntity,
  getLegalEntityProfile,
  patchLegalEntityProfile,
  deleteLegalEntity,
  deleteLegalEntitySignature,
} from "../../helpers/jwt_helper";

function* onGetLegalEntityList({ payload: data }) {
  try {
    yield put(showLegalEntityListLoader());
    let response = yield call(getLegalEntity, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          description: i.description === "string" ? "" : i.description,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setLegalEntityList(response));
    yield put(hideLegalEntityListLoader());
  } catch (error) {
    yield put(hideLegalEntityListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

const getValidLegalEntityData = legal_entity => ({
  contract_number: legal_entity.contract_number,
  date_of_signature: legal_entity.date_of_signature,
  expiration: legal_entity.expiration,
  counterparty_name: legal_entity.counterparty_name,
  legal_address: legal_entity.legal_address,
  postal_address: legal_entity.postal_address,
  settlement_account: legal_entity.settlement_account,
  correspondent_account: legal_entity.correspondent_account,
  bank_name: legal_entity.bank_name,
  bank_address: legal_entity.bank_address,
  swift: legal_entity.swift,
  cpp: legal_entity.cpp,
  inn: legal_entity.inn,
  ogrn: legal_entity.ogrn,
  bic: legal_entity.bic,
  okpo: legal_entity.okpo,
  signer: legal_entity.signer,
  position: legal_entity.position,
  tax_type: legal_entity.tax_type,
  tax_rate: legal_entity.tax_rate,
  type: legal_entity.type,
});

function* onAddLegalEntity({ payload: { legal_entity, data } }) {
  try {
    yield put(showLegalEntityListLoader());
    yield call(postLegalEntity, legal_entity);
    // yield call(onGetLegalEntityList, { payload: data });
    yield put(hideLegalEntityListLoader());
    showSuccessMessage("Legal entity has been added");
  } catch (error) {
    yield put(hideLegalEntityListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteLegalEntity({ payload: { id, data } }) {
  try {
    yield put(showLegalEntityListLoader());
    yield call(deleteLegalEntity, id);
    yield call(onGetLegalEntityList, { payload: data });
    yield put(hideLegalEntityListLoader());
    showSuccessMessage("Legal entity has been deleted");
  } catch (error) {
    yield put(hideLegalEntityListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetLegalEntityProfile({ payload: id }) {
  try {
    yield put(setLegalEntityProfileLoader());
    yield put(setErrorLegalEntityProfile(false));
    let response = yield call(getLegalEntityProfile, id);
    yield put(setLegalEntityProfile(response));
    yield put(setLegalEntityProfileLoader());
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorLegalEntityProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(setLegalEntityProfileLoader());
  }
}

function* onDeleteSignatureImage({ payload: id }) {
  try {
    yield call(deleteLegalEntitySignature, id);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateLegalEntityProfile({
  payload: { id, legal_entity, data, signature },
}) {
  try {
    yield put(showLegalEntityListLoader());
    if (signature === "remove") {
      yield call(onDeleteSignatureImage, { payload: id });
    }
    yield call(patchLegalEntityProfile, id, legal_entity);
    // yield call(onGetLegalEntityList, { payload: data });
    yield put(hideLegalEntityListLoader());
    showSuccessMessage("Legal entity has been updated");
  } catch (error) {
    yield put(hideLegalEntityListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* legalEntityListSaga() {
  yield takeEvery(GET_LEGAL_ENTITY_LIST, onGetLegalEntityList);
  yield takeEvery(DELETE_LEGAL_ENTITY, onDeleteLegalEntity);
  yield takeEvery(ADD_LEGAL_ENTITY, onAddLegalEntity);
  yield takeEvery(GET_LEGAL_ENTITY_PROFILE, onGetLegalEntityProfile);
  yield takeEvery(UPDATE_LEGAL_ENTITY_PROFILE, onUpdateLegalEntityProfile);
}

export default legalEntityListSaga;
